import { StandardRates } from "../../../domain/PracticeProviders/useStandardRateDataForLocationName"
import { getData, buildUrl } from "../apiService"

const apiRoutes = {
  get: {
    RATE_BY_LOCATION_NAME: "/rate/rates/location/:locationName",
    RATES_BY_COUNTY_IN_STATE_OR_TERRITORY:
      "/rate/rates/location/:locationName/parent/:parentName",
  },
}

const rateByLocationName = async (locationName: string) => {
  return getData<StandardRates>(
    buildUrl(apiRoutes.get.RATE_BY_LOCATION_NAME, { locationName }),
  )
}

const ratesByCountyInStateOrTerritory = async (
  countyName: string,
  stateOrTerritoryName: string,
) => {
  return getData<StandardRates>(
    buildUrl(apiRoutes.get.RATES_BY_COUNTY_IN_STATE_OR_TERRITORY, {
      locationName: countyName,
      parentName: stateOrTerritoryName,
    }),
  )
}

export const rateApi = {
  get: {
    RATE_BY_LOCATION_NAME: rateByLocationName,
    RATES_BY_COUNTY_IN_STATE_OR_TERRITORY: ratesByCountyInStateOrTerritory,
  },
}
